<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/motor-edit/'+selected[0].idmotor)"
          >Edit</v-btn>

          <v-btn
            v-if=" selected.length > 0"
            text
            class="ma-2"
            @click="deleteMotor" 
            color="red"
          >Delete</v-btn>

           <v-btn class="ma-2" color="primary" @click="$router.push('/motor-performance-datas')">
            <v-icon left dark>mdi-chart-line-stacked</v-icon>Performance Datas
          </v-btn>

          
          <v-btn class="ma-2" 
          color="primary" @click="$router.push('/motor-add')">Create Motor</v-btn>

                    <v-btn class="ma-2" color="primary" @click="$router.push('/motor-types')">
            <v-icon left dark>mdi-folder</v-icon>Motor Types
          </v-btn>

          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Motors
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idmotor"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="motors"
          :search="search"
        ></v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    selected: [],
    editMotorId: 100,
    search: "",
    motors: [],
    headers: [
      {
        text: "Type",
        align: "left",
        sortable: true,
        value: "type",
        width: 120
      },
      { text: "Power (HP)", value: "power" },
      // { text: "Voltage (V)", value: "voltage" },
      { text: "Nominal Current (A)", value: "nominal_current" },
      // { text: "Frequency", value: "frequency" },
      // { text: "Starting", value: "starting" },
      { text: "Nominal Diameter (mm)", value: "fi_d_max" },
      { text: "Axial Load Capacity", value: "axial_load_capacity" },
      { text: "Starting", value: "starting" },
      { text: "Length (mm)", value: "length" },
      { text: "Weight (kg)", value: "weight" },
      // { text: "Nominal Effiency", value: "nominal_effiency" },
      // { text: "Effiency (%)", value: "effiency" },
      { text: "Phase", value: "phase" },
      { text: "Price ($)", value: "price" },

      // { text: "Cos Fi", value: "cos_fi" },
      // { text: "Frequency (Hz)", value: "frequency" },
      // { text: "Phase", value: "phase" },
    ],

    motor: {
      idmotor: -1,
      type: "XSM 20",
      power: "25",
      axial_load_capacity: 80,
      price: "",
      nominal_current: "13",
      nominal_diameter: "11",
      nominal_effiency: "75",
      effiency: "77",
      phase: 3,
      frequency: 50,
      weight: 4,
      cos_fi: 0.81,
      length: 100,
      voltage: 220-400
    }
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchMotors();
  },
  methods: {
    deleteMotor: function () {

      confirm('Are you sure you want to delete this item?') && this.selected.forEach (this.deleteMotorRequest)
      this.selected = []
      console.log("selected bosaltildi.")

    },
    deleteMotorRequest: function(motor){
      this.$http.get(this.$API_URL + "motor-delete?idmotor="+motor.idmotor).then(result => {
        console.log(result.data)
        if (this.selected.length == 0)
          this.fetchMotors()

      });
    },
    fetchMotors: function() {
      this.$http.get(this.$API_URL + "motors").then(result => {
        this.motors = result.data;
      });
    }
  }
};
</script>
